import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { database } from 'firebase';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.css']
})
export class RoomComponent implements OnInit {

  constructor(public cm:CommonService) { 
    this.cm.getMessage().subscribe((massage)=>{
      if(massage.command == 'menu2'){
        this.clickMenu();
      }
    })

  }

  members = [];
  ngOnInit() {
    this.getRoomFormFirebase();
    const date = new Date();
    this.month_select = date.getMonth() + 1;
    this.year = date.getFullYear();
  }

  isShowMenu = true;
  clickMenu(){
    this.isShowMenu = !this.isShowMenu;
    this.cm.sendMessage('menu',String(this.isShowMenu));
    this.members = this.cm.getMember();
  }


  room:any = [];
  profile;
  project;
  getRoomFormFirebase(){
    this.profile = this.cm.getProfile();
    this.project = this.cm.getProject();
    this.room = [];
    this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').get().toPromise().then((data)=>{
      for(var i = 0; i < data.docs.length;i++){
        this.room.push(data.docs[i].data()); 
      }
      this.cm.saveRoom(this.room);

      this.data_show = this.room;
    })
  }
  room_setting_template = {
    uid:'',
    room_name:'',
    building_name:'',
    floor:'',
    zone:'',
    members:[],
    total:0
  }
  room_setting = this.room_setting_template;

  addRoomToFirebase(){
    if(this.cm.checkinput(this.room_setting.room_name,'>','2') && this.cm.checkinput(this.room_setting.building_name,'>','0')){
      var uid = this.cm.db.createId();
      this.room_setting.uid = uid;
      this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(uid).set(this.room_setting).then((data)=>{
        this.cm.toastr.success('SAVE','SUCCESS');
        this.getRoomFormFirebase();
        this.hideAddRoom();
      })
    }else {
      this.cm.toastr.warning('INPUT ERROR','ERROR');
    }
  }

  showRoomSetting = false;
  hideAddRoom(){
    this.room_setting = this.room_setting_template;
    this.showRoomSetting = false;
    this.is_setting = false;
  }

  is_setting = false;
  members_table = [];
  setRoom(uid){
    this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(uid).get().toPromise().then((data:any)=>{
      this.room_setting = data.data();
      this.showRoomSetting = true;
      this.is_setting = true;


      this.members_table = [];
      for(var i = 0;i < data.data().members.length;i++){
        this.cm.db.collection('members').doc(data.data().members[i]).get().toPromise().then((data)=>{
          this.members_table.push(data.data());
        })
      }

      
    })
  }

  setRoomToFirebase(uid){
    this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(uid).update(this.room_setting).then((data)=>{
      this.cm.toastr.success('SAVE','SUCCESS');
      this.getRoomFormFirebase();
      this.hideAddRoom();
    })
  }

  deleteRoomToFirebase(uid){
    if(confirm('Confirm To Delete Room')){
      this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(uid).delete().then((data)=>{
        this.cm.toastr.success('DELETE','SUCCESS');
        this.getRoomFormFirebase();
        this.hideAddRoom();
      })
    }
  }

  input_emailmember = '';
  addMemberToRoom(){
    // check in room
    var checkMember = true;
    for(var i = 0;i< this.room_setting.members.length;i++){
      if(this.room_setting.members[i] == this.input_emailmember){
        checkMember = false;
      }
    }

    if(this.cm.checkinput(this.input_emailmember,'<',5) || this.input_emailmember == ''){
      this.cm.toastr.warning('อิเมลไม่ถูกต้อง','แจ้งเตือน');
    }

    if(!checkMember){
      this.cm.toastr.warning('สมาชิกอยู่ในห้องแล้ว','แจ้งเตือน');
    }


    
    if(checkMember && this.cm.checkinput(this.input_emailmember,">",5) && this.input_emailmember != ''){
      this.cm.db.collection('members', ref=>ref.where("email","==",this.input_emailmember)).get().toPromise().then((data)=>{
        if(data.docs.length == 1){
          const memberdata = data.docs[0].data();
          if(!memberdata.room_uid){
            var text = ""
            var text = "คุณยืนยันที่จะเพิ่มบุคคลต่อไปนี้ \n";
            text = "ชื่อ : " + memberdata.name + "\n";
            text = text + "เบอร์โทร : " + memberdata.call + " \n";
            text = text + "อิเมล : " + memberdata.email + " \n";
            text = text + "เข้าสู่ห้อง : " + this.room_setting.room_name +" \n";

           if(confirm(text)){
             this.room_setting.members.push(memberdata.uid);
             this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(this.room_setting.uid).update(this.room_setting).then(()=>{
              this.cm.db.collection('members').doc(memberdata.uid).update({
                 project_uid:this.project.uid,
                 room_uid: this.room_setting.uid
               }).then(()=>{

                 this.setRoom(this.room_setting.uid);
                 // add member
                 this.members.push(memberdata);
                 this.cm.saveMember(this.members);
                 this.cm.goto('/dashboard');
               });   
             });
           }

          } else {
            this.cm.toastr.warning('อิเมลลงทะเบียนห้องไว้แล้ว','แจ้งเตือน');
          }
        } else {
          this.cm.toastr.warning('ไม่พบอิเมลในระบบ','แจ้งเตือน');
        }
      })
    }

   

    
  }

  deleteMemberInRoom(room_uid,user_uid){
    if(confirm('Confirm To Delete Member In Room')){
      for(var i = 0;i < this.members_table.length;i++){
        if(this.members_table[i].uid == user_uid){
          this.members_table.splice(i,1);
          break;
        }
      }

      var dataupdate = {
        members:this.members_table
      }
      this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(this.room_setting.uid).update(dataupdate).then(()=>{
        this.cm.db.collection('members').doc(user_uid).update({
          project_uid:"",
          room_uid:""
        }).then(()=>{
          //this.hideAddRoom();
          this.setRoom(this.room_setting.uid);
        });
       
      });
    }
  }

  activity = [];
  showRoomActivity = false;
  room_activity_name = "";
  room_uid_now;
  showActivity(room_uid){
    this.room_activity_name = this.checkNameRoomActivity(room_uid);
    this.room_uid_now = room_uid
    this.getActivity();
  }

  getActivity(){
    var firstDay = new Date(this.year, this.month_select - 1, 1);
    var lastDay = new Date(this.year, this.month_select, 1); 
    this.activity = [];
    this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(this.room_uid_now).collection('activity',ref=>ref.where('create_time','>',firstDay.getTime()).where('create_time','<',lastDay.getTime())).get().toPromise().then((data)=>{
    // this.cm.db.collection('projects').doc(this.project.uid).collection('rooms').doc(this.room_uid_now).collection('activity',ref=>ref.orderBy('create_time','desc').limit(25)).get().toPromise().then((data)=>{
      for(var i = 0;i < data.docs.length;i++){
        this.activity.push(data.docs[i].data());
      }
      this.showRoomActivity = true;

      
    });
  }

  checkNameRoomActivity(uid){
    for(var i = 0; i < this.room.length;i++){
      if(this.room[i].uid == uid){
        return this.room[i].room_name;
      }
    }
  }

  hideActivity(){
    this.showRoomActivity = false;
  }

  setCard(uid){
    let card_number = window.prompt("CARD NUMBER","");
    var member_data = this.cm.getDataMemberFromUID(uid);

    if(this.cm.checkinput(card_number,">",6 )){
      this.cm.db.collection('cards', ref => ref.where('card_number','==',card_number)).get().toPromise().then((data)=>{
      
        // check have data

        

        
        if(data.docs[0].data() && data.docs.length == 1 && !data.docs[0].data().member_uid){
           var card_data = data.docs[0].data()
  
          //set card
           var card_set = {
             call        : member_data.call,
             member_uid  : member_data.uid,
             project_uid : member_data.project_uid,
             room_uid    : member_data.room_uid,
           } 

          
          this.cm.db.collection('cards').doc(card_data.uid).update(card_set);
    
            //set member
            var card_uid_data = [];
            var card_number_data = [];
            if(member_data.card_uid &&  member_data.card_number){
              for(var i = 0; i < member_data.card_uid.length;i++){
                card_uid_data.push(member_data.card_uid[i]);
              }
              
    
              for(var i = 0; i < member_data.card_number.length;i++){
                card_number_data.push(member_data.card_number[i]);
              }
             
            }
            
            card_uid_data.push(card_data.rfid_uid);
            card_number_data.push(card_data.card_number);
            
            var member_set = {
              card_uid : card_uid_data,
              card_number : card_number_data,
            }

            

            this.cm.db.collection('members').doc(member_data.uid).update(member_set).then((data)=>{
              member_data.card_uid = member_set.card_uid;
              member_data.card_number = member_set.card_number;
              this.cm.saveDataMemberFromUID(member_data.uid,member_data);

              
              this.cm.toastr.success("SUCCESS","SAVE DATA");
             
              this.setRoom(member_data.room_uid);
            });
  
         } else if (data.docs[0].data().member_uid) {
            this.cm.toastr.warning("WARNING","USE")
         }
       
  
       });
    } else {
      this.cm.toastr.warning("WARNING","NUMBER IS NULL")
    }
  }

  delCard(card_number,member_data,position){
    if(confirm("CONFIREM DELETE CARD")){
      //set card
      var card_set = {
        call        : "",
        member_uid  : "",
        project_uid : "",
        room_uid    : "",
      } 
      this.cm.db.collection('cards',ref => ref.where('card_number','==',card_number)).get().toPromise().then((data)=>{
        if(data.docs[0].data() && data.docs.length == 1){
          var card_data = data.docs[0].data();
          this.cm.db.collection('cards').doc(card_data.uid).update(card_set).then((data)=>{
            this.setRoom(member_data.room_uid);
            this.cm.toastr.success("SUCCESS","DELETE CARD");
          });
        }
      })
     

      //set member
      var card_uid_data = [];
      for(var i = 0; i < member_data.card_uid.length;i++){
        card_uid_data.push( member_data.card_uid[i]);
      }
      card_uid_data.splice(position,1);

      var card_number_data = [];
      for(var i = 0; i < member_data.card_number.length;i++){
        card_number_data.push(member_data.card_number[i]);
      }
      card_number_data.splice(position,1);
      
      var member_set = {
        card_uid : card_uid_data,
        card_number : card_number_data,
      }

      member_data.card_uid = member_set.card_uid;
      member_data.card_number = member_set.card_number;
      this.cm.saveDataMemberFromUID(member_data.uid,member_data);

      this.cm.db.collection('members').doc(member_data.uid).update(member_set);
    }
  }

  getReport(room){
    this.cm.encryption_service.set_secure_item("report_room", room);
    this.cm.goto("/report");
  }

  month_select;
  year;
  selectMonth(month){

    const date = new Date();
    // this.getReport(this.year,month);
    this.getActivity();
    
  }

  selectYear(year){

    const date = new Date();
    // this.getReport(year,this.month_select);
    this.getActivity();
  }

  @ViewChild("input_search_text") inputEl: ElementRef;
  data_show;
  search(text){
    this.data_show = [];
    for(var i = 0;i<this.room.length;i++){
      var sameData = 0;
      for (var key in this.room[i]) {
        if(String(this.room[i][key]).match(text)){
            this.data_show.push(this.room[i]);
            sameData = 1;
        }

        for (var key in this.room[i].attribute) {
          if(String(this.room[i].attribute[key]).match(text) && sameData == 0){
              this.data_show.push(this.room[i]);
          }
        } 
        sameData = 0;
      } 
    }
    this.data_show = this.cm.removeDuplicates(this.data_show,'uid');
  }


}
